import {createAction, createReducer} from '@reduxjs/toolkit';

import {OrderDetailsItemsType} from 'types/orderDetailsTypes';

import {postEyeExam, saveOrder} from '../../actions/orderItems/orderItems';

type DrawerPopupType = {
    isOpen: boolean;
    item: OrderDetailsItemsType | null;
    title: string;
    rxMethod: string;
};

export const initialState: DrawerPopupType = {
    isOpen: false,
    item: null,
    rxMethod: '',
    title: '',
};

export const setDrawerState = createAction<boolean>('SUCCESS_PAGE@SET_DRAWER_STATE');
export const setDrawerMethod = createAction<{rxMethod: string; title?: string; isOpen?: boolean}>(
    'SUCCESS_PAGE@SET_DRAWER_METHOD',
);
export const openDrawerAndSetItem = createAction<{item: OrderDetailsItemsType; title: string}>(
    'SUCCESS_PAGE@OPEN_DRAWER_AND_SET_ITEM',
);
export const updateItem = createAction<OrderDetailsItemsType>('SUCCESS_PAGE@UPDATE_ITEM');

export const drawerPopup = createReducer<DrawerPopupType>(initialState, builder => {
    builder.addCase(setDrawerState, (state, {payload}) => ({
        ...state,
        isOpen: payload,
    }));
    builder.addCase(setDrawerMethod, (state, {payload: {isOpen, rxMethod, title}}) => ({
        ...state,
        isOpen: isOpen || state.isOpen,
        rxMethod,
        title: title || state.title,
    }));
    builder.addCase(saveOrder.fulfilled, state => ({
        ...state,
        isOpen: false,
    }));
    builder.addCase(postEyeExam.fulfilled, state => ({
        ...state,
        isOpen: false,
    }));
    builder.addCase(updateItem, (state, {payload}) => ({
        ...state,
        item: payload,
    }));
    builder.addCase(openDrawerAndSetItem, (_, {payload: {item, title}}) => ({
        ...initialState,
        isOpen: true,
        item,
        title,
    }));
});
